import React, { useState } from 'react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CloseIcon from '@mui/icons-material/Close'
import { DateRange } from 'react-date-range'
import { Grid, Menu, Typography } from '@mui/material'
import useStyles from './useStyles'
import RouteModal from '../../../../../components/Modals/Storage/RouteModal'

export const Filters = ({
  valueFilter,
  setvalueFilter,
  dateValue,
  setdateValue,
  handleGetFilterRecycle,
  resetFilterName,
  resetFilterDate,
  handleGetAllRecycle,
  handleClick,
  routeValue,
  setRouteValue,
  resetFilterRoute
}) => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [openModal, setOpenModal] = React.useState(false)
  const handleOpen = () => setOpenModal(true)

  const handleCloseModalDate = () => {
    setAnchorEl(null)
  }
  const handleOpenFilterDate = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }

  const handleGetAllDocuments = async () => {
    if (valueFilter || dateValue || routeValue) {
      setvalueFilter(false)
      setdateValue(false)
      setRouteValue(false)
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection'
        }
      ])
      await handleGetAllRecycle()
    }
  }
  return (
    <div className={classes.boxfilters}>
      <Grid
        container
        style={{
          width: '85%',
          display: 'flex',
          alignItems: 'center',
          color: '#028B7E'
        }}
      >
        <Grid item>
          <Typography className={classes.typography}>Mostrar por:</Typography>
        </Grid>

        <Grid item>
          <Typography
            className={classes.typographyFilters}
            onClick={handleOpen}
          >
            Ruta {routeValue ? ' (1) ' : ''}
          </Typography>
        </Grid>
        <RouteModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleClick={handleClick}
          handleGetFilterRecycle={handleGetFilterRecycle}
        />
        <Grid item>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              className={classes.typographyFilters}
              onClick={handleOpenFilterDate}
            >
              Período de eliminación{dateValue && ':'}
            </Typography>
            {!dateValue && <ArrowDropDownIcon onClick={handleOpenFilterDate} />}
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseModalDate}
            >
              <DateRange
                editableDateInputs={true}
                ranges={date}
                onChange={async (item) => {
                  setDate([item.selection])
                  setdateValue(item.selection)
                  await handleGetFilterRecycle('search_date', item.selection)
                }}
                moveRangeOnFirstSelection={false}
                months={2}
                direction={'horizontal'}
              />
            </Menu>
            {dateValue && (
              <button className={classes.buttonResetFilter}>
                <Typography className={classes.typographyButton}>
                  {formatDate(dateValue.startDate) +
                    (dateValue.startDate !== dateValue.endDate
                      ? ' - ' + formatDate(dateValue.endDate)
                      : '')}
                </Typography>
                <CloseIcon
                  className={classes.closeIconButtonReset}
                  onClick={async () => {
                    setdateValue(null)
                    setDate([
                      {
                        startDate: new Date(),
                        endDate: new Date(),
                        key: 'selection'
                      }
                    ])
                    await resetFilterDate()
                  }}
                />
              </button>
            )}
          </div>
        </Grid>

        <Grid item>
          {valueFilter && valueFilter !== '' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <button
                className={classes.buttonResetFilter}
                onClick={async () => {
                  setvalueFilter(null)
                  await resetFilterName()
                }}
              >
                <Typography className={classes.typographyButton}>
                  {valueFilter}
                </Typography>
                <CloseIcon className={classes.closeIconButtonReset} />
              </button>
            </div>
          )}
        </Grid>
      </Grid>
      <div
        style={{
          width: '15%',
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        {valueFilter || dateValue || routeValue
          ? (
          <Typography
            className={classes.typographyFilters}
            onClick={handleGetAllDocuments}
          >
            Restablecer filtros
          </Typography>
            )
          : null}
      </div>
    </div>
  )
}
